<template>
  <component :is="$snippets[layoutComponent]" />
</template>

<script>
import context from '@/context'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
import loadDirectives from '../directives'
import '../store'
import { loadIcons } from 'nette-base-module/js/components/AwIcon'
import loadComponents from '../components'
// import store from '../store'
import './index'

export default {
  name: 'Layout',
  setup () {
    loadDirectives(context.vueApp, context)

    // load icons
    loadIcons(require.context(
      // root folder for components
      '!raw-loader!../svg/',
      // recursive
      false,
      // include all .js wo index.js
      /\.svg$/,
    ))
    loadComponents(context.vueApp, context)
  },
  data () {
    return {
      layoutComponent: context.rootElementId
    }
  },
  beforeRouteEnter (to, from) {
    console.log('beforeRouteEnter', from, to)
    // do not call when only hash change
    if (to.fullPath.substr(0, (to.fullPath.length - to.hash.length)) === from.fullPath.substr(0, (from.fullPath.length - from.hash.length)))
      return
    NetteAjax.ext('vue-router').onRouteWillChange(to, from)
  },
  async beforeRouteUpdate (to, from) {
    console.log('beforeRouteUpdate', from, to)
    // do not call when only hash change
    if (to.fullPath.substr(0, (to.fullPath.length - to.hash.length)) === from.fullPath.substr(0, (from.fullPath.length - from.hash.length)))
      return

    return await NetteAjax.ext('vue-router').onRouteWillChange(to, from)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../scss/screen.scss";
</style>
